import ol_ext_inherits from 'ol-ext/util/ext'
import ol_filter_Mask from 'ol-ext/filter/Mask'
import ol_style_Fill from 'ol/style/Fill'
import {
    unByKey as ol_Observable_unByKey
}
from 'ol/Observable'
import ol_format_WKT from 'ol/format/WKT'
import ol_format_GeoJSON from 'ol/format/GeoJSON'

//overwrite functions

ol_filter_Mask.prototype.drawFeaturePath_ = function (e, out) {
    var ctx = e.context;
    var canvas = ctx.canvas;
    var ratio = e.frameState.pixelRatio;
    // Transform
    var m = e.frameState.coordinateToPixelTransform;
    var tr

    tr = function (pt) {
            return [(pt[0] * m[0] + pt[1] * m[1] + m[4]) * ratio,
                (pt[0] * m[2] + pt[1] * m[3] + m[5]) * ratio];
        }
        // Old version
    if (!m) {
        m = e.frameState.coordinateToPixelMatrix;
        tr = function (pt) {
            return [(pt[0] * m[0] + pt[1] * m[1] + m[12]) * ratio,
                (pt[0] * m[4] + pt[1] * m[5] + m[13]) * ratio];
        }
    }
    // Geometry
    var ll = this.feature_.getGeometry().getCoordinates();
    if (this.feature_.getGeometry().getType() == "Polygon")
        ll = [ll];
    ctx.beginPath();
    if (out) {
        // draw outer bounds with offset because we want a stroke for the
        // inner path but not for the outer
        // stroke is one pixel and now out of view with the offset
        ctx.moveTo(-1, -1);
        ctx.lineTo(canvas.width + 1, -1);
        ctx.lineTo(canvas.width + 1, canvas.height + 1);
        ctx.lineTo(-1, canvas.height + 1);
        ctx.lineTo(-1, -1);
    }
    for (var l = 0; l < ll.length; l++) {
        var c = ll[l];
        for (var i = 0; i < c.length; i++) {
            var pt = tr(c[i][0]);
            ctx.moveTo(pt[0], pt[1]);
            for (var j = 1; j < c[i].length; j++) {
                pt = tr(c[i][j]);
                ctx.lineTo(pt[0], pt[1]);
            }
        }
    }
};

ol_filter_Mask.prototype.postcompose = function (e) {
    if (!this.feature_)
        return;
    var ctx = e.context;
    ctx.save();
    this.drawFeaturePath_(e, !this.get("inner"));
    ctx.fillStyle = this.fillColor_;
    ctx.fill("evenodd");

    // add stroke
    ctx.lineWidth = 1;
    // set line color
    ctx.strokeStyle = '#000000';
    ctx.stroke();
    ctx.restore();
}

/** A simple toggle control
 * The control can be created with an interaction to control its activation.
 *
 * @constructor
 * @extends {ol_control_Control}
 * @fires change:active, change:disable
 * @param {Object=} options Control options.
 *	@param {String} options.className class of the control
 *	@param {String} options.title title of the control
 *	@param {String} options.html html to insert in the control
 *	@param {ol.interaction} options.interaction interaction associated with the control
 *	@param {bool} options.active the control is created active, default false
 *	@param {bool} options.disable the control is created disabled, default false
 *	@param {ol.control.Bar} options.bar a subbar associated with the control (drawn when active if control is nested in a ol.control.Bar)
 *	@param {bool} options.autoActive the control will activate when shown in an ol.control.Bar, default false
 *	@param {function} options.onToggle callback when control is clicked (or use change:active event)
 */
var ol_filter_BorderMask = function (options) {
    options = options || {};

    this.maskGeoms = {}

    var wktOptions = {};
    if(options.dataProjection) {
	    wktOptions.dataProjection=options.dataProjection
    }
    if(options.dataProjection) {
	    wktOptions.featureProjection=options.featureProjection
    }
    if (options.wkt) {
        this.maskGeoms.feature = new ol_format_WKT().readFeature(options.wkt,wktOptions);
        this.maskGeoms.geom = this.maskGeoms.feature.getGeometry();
    }
    if (options.geojson) {
        this.maskGeoms.feature = new ol_format_GeoJSON().readFeature(options.geojson,wktOptions);
        this.maskGeoms.geom = this.maskGeoms.feature.getGeometry();
    }
    options.feature = this.maskGeoms.feature
    options.inner = false
    options.fill = new ol_style_Fill({
        color: [238, 238, 238, 0.7]
    })


    ol_filter_Mask.call(this, options);
};

ol_ext_inherits(ol_filter_BorderMask, ol_filter_Mask);

/**
 * Set the map instance the control is associated with.
 * @param {_ol_Map_} map The map instance.
 */
ol_filter_BorderMask.prototype.setMap = function (map) {
    ol_filter_Mask.prototype.setMap.call(this, map);

    if (this._listener) {
        if (this._listener.change) {
            ol_Observable_unByKey(this._listener.change)
        }
    }
    this._listener = null;

    // Get change (new layer added or removed)
    if (map) {
        this._listener = {
            change: map.getView().on('change:resolution', this.simplify.bind(this))
        }
    }
};


ol_filter_BorderMask.prototype.simplify = function () {
    var map = this.getMap();

    if (map.getView().getZoom() % 1 === 0) {
        if (!this.maskGeoms.hasOwnProperty(map.getView().getZoom())) {
            this.maskGeoms[map.getView().getZoom()] = this.maskGeoms.geom.simplify(map.getView().getResolution()); // 8
        }
        this.maskGeoms.feature.setGeometry(this.maskGeoms[map.getView().getZoom()]);
        this.feature_ = this.maskGeoms.feature;
    }
}


export default ol_filter_BorderMask